<template>
  <div>
    <h4>我是微信公众号登录页</h4>
    <h5>return code: </h5>
    <h5>{{ wx_code }}</h5>
    <hr>
    <h5>return state: </h5>
    <h5>{{ wx_state }}</h5>
    <button @click="mainPage">主页</button>
  </div>
</template>

<script>
import {getWXLogin} from "../../network/wx/wxmp";
import {app} from "../../network/app/app";

//1.第一步：在微信客户端调用以下URL,
//'https://open.weixin.qq.com/connect/oauth2/authorize?
// appid=wx0436c2e9ea60fce2
// &redirect_uri=https://tddev.toodo.com.cn/webkepu/wxlogin/
// &response_type=code
// &scope=snsapi_userinfo
// &state=lwlhello
// #wechat_redirect'

//2.用户同意授权，返回code及state=lwlhello
//第二步：通过code换取网页授权access_token
//说明：这一步是通过科普服务接口获取acccess_token
//理由：通过科普服务接口处理，方便服务端用户统一管理

export default {
  name: "login",
  data(){
    return {
      wx_code: '12345667',
      wx_state: 'test'
    }
  },
  created() {
    app.disable()
    console.log('login created');
  },
  destroyed() {
    console.log('login destroyed');
  },
  mounted() {
    console.log('login mounted');
    this.wx_code = this.$route.query.code
    this.wx_state = this.$route.query.state //为调用前的参数
    getWXLogin({'code': this.wx_code}).then(res=>{
      console.log('微信登录成功');
      console.log(res)
      alert('微信登录成功')
      alert(JSON.stringify(res))
    }).catch(err=>{
      console.log('微信登录失败');
      console.log(err)
      alert('微信登录失败')
      alert(JSON.stringify(err))
    })
  },
  methods:{
    mainPage(){
      this.$router.push({ name: 'home', params: {}})
    }
  }
}
</script>

<style scoped>

</style>